import { ModuleWithProviders, NgModule, Optional, SkipSelf } from "@angular/core";
import { FirebaseConfig } from "./firebase.service";

@NgModule()
// Tslint:disable-next-line:no-unnecessary-class
export class FirebaseModule {
	public constructor(@Optional() @SkipSelf() parentModule?: FirebaseModule) {
		if (parentModule) {
			throw new Error("Firebase is already loaded. Import it in the AppModule only!");
		}
	}

	public static forRoot(config: FirebaseConfig): ModuleWithProviders<FirebaseModule> {
		return {
			ngModule: FirebaseModule,
			providers: [{ provide: FirebaseConfig, useValue: config }]
		};
	}
}
